const microApps = {
  MYDISHPPV: { path: '/payperview', baseId: 'mydishppv' },
  SUPPORT: { path: '/support', baseId: 'csaweb' }
};

const toSameApp = (
  destination: string,
  incoming: string = window.location.pathname
) => {
  if (!destination.startsWith('/')) return false;
  let appId = 'mydish';
  let destinationId = 'mydish';
  Object.values(microApps).forEach((app) => {
    const appUrl = app.path;
    if (incoming.startsWith(appUrl)) appId = app.baseId;
    if (destination.startsWith(appUrl)) destinationId = app.baseId;
  });
  return appId === destinationId;
};

const navigate = (destination: string, history?: any) => {
  let sameApp = toSameApp(destination);
  if (history && sameApp) {
    history.push(destination);
  } else {
    window.location.href = destination;
  }
};

export { microApps, toSameApp, navigate };
